const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/message.ts';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';
import { createNoAuthPatapiCall, HttpMethod } from 'App/utils/fetchUtils';

export const REQUEST_ACTION_TYPES_MESSAGES = kisapiActionTypes('PATAPP_LOAD_MESSAGES');

export function loadMessages() {
    const endpoint = `/settings/messages`;
    return createNoAuthPatapiCall(REQUEST_ACTION_TYPES_MESSAGES, endpoint, HttpMethod.GET);
}
